"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbDataTableTbody = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _sbDataTableTd = require("./sb-data-table-td");

var _sbDataTableTr = require("./sb-data-table-tr");

var _utils = require("./utils");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LEFT = _constants.expandedRowsArrowPositions.LEFT,
    RIGHT = _constants.expandedRowsArrowPositions.RIGHT;

var SbDataTableTbody = /*#__PURE__*/function (_Component) {
  _inherits(SbDataTableTbody, _Component);

  var _super = _createSuper(SbDataTableTbody);

  function SbDataTableTbody() {
    _classCallCheck(this, SbDataTableTbody);

    return _super.apply(this, arguments);
  }

  _createClass(SbDataTableTbody, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _isEqual.default)(nextProps, this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cellFormatter = _this$props.cellFormatter,
          columns = _this$props.columns,
          data = _this$props.data,
          rowFormatter = _this$props.rowFormatter,
          rowsUniqueKeyName = _this$props.rowsUniqueKeyName,
          maxIndex = _this$props.maxIndex,
          minIndex = _this$props.minIndex,
          asyncData = _this$props.asyncData,
          expandableRowFormatter = _this$props.expandableRowFormatter,
          onExpandRow = _this$props.onExpandRow,
          expandedRows = _this$props.expandedRows,
          expandableRowsArrowPosition = _this$props.expandableRowsArrowPosition;
      var filteredData = !asyncData && (maxIndex || minIndex) ? (0, _utils.getSubsetOfItems)({
        minIndex: minIndex,
        maxIndex: maxIndex,
        data: data,
        isGroup: false
      }) : data;
      var tableRows = filteredData.map(function (row, rowIndex) {
        var rowUniqueIndex = rowsUniqueKeyName && row[rowsUniqueKeyName] !== undefined ? row[rowsUniqueKeyName] : rowIndex;
        var expandedRow = expandableRowFormatter === null || expandableRowFormatter === void 0 ? void 0 : expandableRowFormatter(row);
        var isOdd = rowIndex % 2 === 1;
        var expanded = expandedRows.indexOf(rowUniqueIndex) !== -1;
        var tableCells = columns.map(function (_ref) {
          var name = _ref.name,
              key = _ref.key,
              cellsStyle = _ref.cellsStyle,
              cellsClassName = _ref.cellsClassName,
              hidden = _ref.hidden;
          if (hidden) return null;
          var cellData = cellFormatter(row[name], key || name, row, data);
          var isCellDataConfObject = (0, _utils.isConfObject)(cellData);

          var _ref2 = isCellDataConfObject ? cellData : {},
              cell = _ref2.value,
              className = _ref2.className,
              style = _ref2.style,
              props = _objectWithoutProperties(_ref2, ["value", "className", "style"]);

          return /*#__PURE__*/_react.default.createElement(_sbDataTableTd.SbDataTableTd, _extends({
            key: "sb-data-table-tbody-tr-td-".concat(rowUniqueIndex, "-").concat(key || name),
            className: (0, _classnames.default)(className, cellsClassName),
            style: Object.assign({}, style, cellsStyle)
          }, props), !isCellDataConfObject ? cellData : cell);
        }); // We expecting an object of props from the rowFormatter, nothing else is allowed.

        var rowProps = rowFormatter(row, data);

        if ((0, _utils.isConfObject)(rowProps)) {
          var onClick = rowProps.onClick,
              className = rowProps.className,
              restRowProps = _objectWithoutProperties(rowProps, ["onClick", "className"]);

          var onExpandRowClick = expandedRow ? function (e) {
            return onExpandRow(e, rowUniqueIndex);
          } : null;
          var onRowClick = onClick || onExpandRowClick; // Expand/Collapse arrow and empty cells

          if (expandableRowFormatter) {
            var cell = expandedRow ? /*#__PURE__*/_react.default.createElement(_sbDataTableTd.SbDataTableTd, {
              key: "sb-data-table-tbody-tr-td-".concat(rowUniqueIndex, "-expand-arrow"),
              className: "expand-cell",
              onClick: onExpandRowClick
            }, /*#__PURE__*/_react.default.createElement("i", {
              className: "sbi-chevron-".concat(expanded ? 'up' : 'down')
            })) : /*#__PURE__*/_react.default.createElement("td", {
              className: "empty-cell",
              key: "placeholder-td-".concat(rowUniqueIndex)
            });

            if (expandableRowsArrowPosition === RIGHT) {
              tableCells.push(cell);
            } else {
              tableCells.unshift(cell);
            }
          }

          var tr = [/*#__PURE__*/_react.default.createElement(_sbDataTableTr.SbDataTableTr, _extends({
            key: "sb-data-table-tbody-tr-".concat(rowUniqueIndex)
          }, restRowProps, {
            onClick: onRowClick,
            className: (0, _classnames.default)(className, {
              odd: isOdd,
              pointer: !!onRowClick
            })
          }), tableCells)];

          if (expandedRow) {
            tr.push( /*#__PURE__*/_react.default.createElement(_sbDataTableTr.SbDataTableTr, {
              key: "sb-data-table-tbody-tr-subrow-".concat(rowUniqueIndex),
              className: (0, _classnames.default)('expanded-row', {
                expanded: expanded,
                odd: isOdd
              })
            }, /*#__PURE__*/_react.default.createElement(_sbDataTableTd.SbDataTableTd, {
              colSpan: 100
            }, expandedRow)));
          }

          return tr;
        }

        console.warn('rowFormatter must return an Object!');
        return null;
      });
      return /*#__PURE__*/_react.default.createElement("tbody", null, tableRows);
    }
  }]);

  return SbDataTableTbody;
}(_react.Component);

exports.SbDataTableTbody = SbDataTableTbody;

_defineProperty(SbDataTableTbody, "propTypes", {
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    label: _propTypes.default.node
  })).isRequired,
  data: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  rowsUniqueKeyName: _propTypes.default.string,
  cellFormatter: _propTypes.default.func,
  rowFormatter: _propTypes.default.func,
  expandableRowFormatter: _propTypes.default.func,
  minIndex: _propTypes.default.number,
  maxIndex: _propTypes.default.number,
  asyncData: _propTypes.default.bool,
  onExpandRow: _propTypes.default.func,
  expandedRows: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
  expandableRowsArrowPosition: _propTypes.default.oneOf([LEFT, RIGHT])
});

_defineProperty(SbDataTableTbody, "defaultProps", {
  rowsUniqueKeyName: null,
  cellFormatter: function cellFormatter(val) {
    return val;
  },
  rowFormatter: function rowFormatter() {
    return {};
  },
  expandableRowFormatter: null,
  minIndex: null,
  maxIndex: null,
  asyncData: false,
  onExpandRow: function onExpandRow() {},
  expandedRows: [],
  expandableRowsArrowPosition: RIGHT
});
//# sourceMappingURL=sb-data-table-tbody.js.map